const jQ = jQuery.noConflict();

class SetState {
    constructor(args) {
        this.selector = args.sel;
        this.item = args.item;
        this.close = args.close;
    }

    setActive(e) {
        e.preventDefault();
        if (jQ(this.item).length && !jQ(this.item).hasClass('active')) {
            jQ(this.item).addClass('active');
        }
    }
    closePopup(e) {
        e.preventDefault();
        jQ(this).parents('.page-popup').removeClass('active');
    }
    hideOnOuterClick(e) {
        var container = jQ(".page-popup-content");

        if (!container.is(e.target) && container.has(e.target).length === 0) {
            jQ('.page-popup').removeClass('active');
        }
    }
    init() {
        const sel = this.selector;
        const esc = this.close;
        const that = this;
        jQ(sel).on('click', e => this.setActive(e));
        jQ(esc).on('click', this.closePopup);
        jQ(document).mouseup( this.hideOnOuterClick);
    }
}


export default SetState;
